<template>
  <v-card>
    <v-card-title>ムダミエールボタン(非使用)</v-card-title>
    <v-card-text>
      <v-container>
        ボタンフォームに機能が移行しました。
        <v-row>
          <v-col cols="12">
            <v-text-field
              label="ラベル名"
              v-model="returnData.label"
              required
            ></v-text-field>
          </v-col>
          <!--
          <v-col cols="12">
            <v-text-field
              label="初期値"
              v-model="returnData.init"
              required
            ></v-text-field>
          </v-col>
          -->
        </v-row>
        <v-row>
          <v-col cols="6">
            <p>時間表示 ※無効</p>
            <v-radio-group label="" v-model="rules[0]" column>
              <v-radio label="時間：分：秒" value="0"></v-radio>
              <v-radio label="時間：分" value="1"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6">
            <p>中断ボタン ※無効</p>
            <v-radio-group label="" v-model="rules[1]" column>
              <v-radio label="無" value="0"></v-radio>
              <v-radio label="有" value="1"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="success" @click.once="submit">OK</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    label: String,
    init: String,
    type: Number,
    position: Number,
    size: Number,
    //rule: String,
  },
  data() {
    return {
      returnData: {
        label: this.label,
        init: this.init,
        type: this.type,
        position: this.position,
        size: this.size,
        //rule: this.rule,
      },
      rules: [],
    };
  },
  mounted() {
    //this.rules = this.rule.split(",");
  },

  methods: {
    submit() {
      this.returnData.rule = this.rules.join(",");
      this.$emit("clickSubmit", this.returnData);
    },
  },
};
</script>
